import type {
  SelectProps,
} from '@mui/material/Select';
import isNil from 'lodash/isNil';
import dayjs from 'utils/dayjs';

export const fallbackYearWindow = {
  past: 100,
  future: 50,
} as const;

export function getYearOptions(
  startYear: number,
  endYear: number,
) {
  return Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
}

export function getYearRange(
  startMonth: Date | undefined,
  endMonth: Date | undefined,
  currentMonth: Date,
) {
  const currentYear = dayjs(currentMonth).year();
  let startYear = currentYear - fallbackYearWindow.past;
  let endYear = currentYear + fallbackYearWindow.future;

  if (!isNil(startMonth)) {
    startYear = dayjs(startMonth).year();
  } else if (!isNil(endMonth)) {
    startYear = dayjs(endMonth).year() - fallbackYearWindow.past;
  }

  if (!isNil(endMonth)) {
    endYear = dayjs(endMonth).year();
  } else if (!isNil(startMonth)) {
    endYear = dayjs(startMonth).year() + fallbackYearWindow.future;
  }

  return {
    startYear,
    endYear,
  };
}

export const yearMenuProps: NonNullable<SelectProps<number>['MenuProps']> = {
  variant: 'menu',
  disableScrollLock: true,
  slotProps: {
    paper: {
      style: {
        maxHeight: 320,
        opacity: 0,
      },
    },
    transition: {
      onEnter: (element: HTMLElement) => {
        const list = element.querySelector('.MuiList-root') as HTMLElement | null;
        const selected = list?.querySelector('.Mui-selected') as HTMLElement | null;

        if (selected) {
          selected.scrollIntoView({
            block: 'center',
            behavior: 'instant',
          });
          selected.focus({ preventScroll: true });
        }

        element.style.opacity = '1';
      },
    },
  },
};
